import { render, staticRenderFns } from "./WhereToBuy.vue?vue&type=template&id=10b9a95a&scoped=true&"
import script from "./WhereToBuy.vue?vue&type=script&lang=ts&"
export * from "./WhereToBuy.vue?vue&type=script&lang=ts&"
import style0 from "./WhereToBuy.vue?vue&type=style&index=0&id=10b9a95a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9a95a",
  null
  
)

export default component.exports